import React, { Component } from 'react'
import { IContainerCustomization } from '../PartnerCustomizations'
import {
  UniKeyV1CredentialC,
  RawCredentialC,
  WiegandCredentialC,
  Corp1000CredentialC,
  TSBnFCredentialC,
  TSBwFCredentialC,
  ECredentialType,
  IPartnerCredImpls,
  ES10nModelType,
  StringCredentialC,
} from '@unikey/unikey-commons/release/comm'

const dealerSkinningOffered = false;

export default () => {

  const partnerCredImpls: IPartnerCredImpls = {
    PartnerSCred: StringCredentialC,
    PartnerRCred: RawCredentialC,
    PartnerWCred: WiegandCredentialC,
    PartnerU1Cred: UniKeyV1CredentialC,
    PartnerC1000Cred: Corp1000CredentialC,
    Partner37BwFCred: TSBwFCredentialC,
    Partner37BnFCred: TSBnFCredentialC,
  };

  const partnerCredImplAvailability: ECredentialType[] = [
    ECredentialType.wiegand44Bit,
    ECredentialType.unikeyV1,
    ECredentialType.corp1000,
    ECredentialType.tsbNfacility,
    ECredentialType.tsbWfacility,
  ];

  const CredentialCreate: IContainerCustomization = {
    props: {
      partnerCredImplAvailability,
      partnerCredImpls,
      partnerDefaultCredentialType: ECredentialType.wiegand44Bit,
      partnerCsvExampleTemplate: (
        <>
          <p>EMAIL,FACILITY_CODE,CARD_NUMBER,TYPE</p>
          <p>address1@example.com,55,12345,wiegand</p>
          <p>address2@example.com,44,65432,corp1000</p>
          <p>address3@example.com,,987654321,37bit</p>
          <p>address4@example.com,88,5678,37bitwfacility</p>

          <br /> -- or -- <br /> <br />

          <p>EMAIL,CREDENTIAL_DATA_BIT_LENGTH,CREDENTIAL_DATA_HEX,TYPE</p>
          <p>address7@example.com,12,0xFAB,custom</p>
          <p>address8@example.com,7,0x44,custom</p>
          <p>address8@example.com,16,0xFAFA,custom</p>
        </>
      ),
      preventBase64CredentialDataInput: true
    }
  }

  const CredentialList: IContainerCustomization = {
    props: {
      partnerCredImpls,
      partnerDefaultCredentialType: ECredentialType.wiegand44Bit
    }
  }

  const CredentialDetails: IContainerCustomization = {
    props: {
      partnerCredImpls,
      partnerDefaultCredentialType: ECredentialType.wiegand44Bit
    }
  }

  const DeviceList: IContainerCustomization = {
    props: {
      partnerCredImpls
    }
  }

  const DealerRegisterForm: IContainerCustomization = {
    props: {
      dealerSkinningOffered,
      // TOOD: remove this once we have proper branded subscription models
      // limiting on the front end since they are currently all available in the uni environment
      temporaryDisallowedSubscriptionModels: [ ES10nModelType.credAndUser, ES10nModelType.reader ] 
    }
  }
  
  const DealerDetails: IContainerCustomization = {
    props: {
      dealerSkinningOffered
    }
  }

  const Portal: IContainerCustomization = {
    props: {
      dealerSkinningOffered
    }
  }

  const PortalPrereq: IContainerCustomization = {
    props: {
      dealerSkinningOffered
    }
  }

  return {
    Portal,
    PortalPrereq,
    CredentialCreate,
    CredentialList,
    CredentialDetails,
    DealerRegisterForm,
    DealerCreate: DealerRegisterForm,
    DeviceList,
    DealerDetails
  }
}
